<div class="x-load" [ngClass]="{ 'loader-over': loaderOverItem, 'p-0': noPadding }">
  <!-- <div class="x-img"> -->
  <div class="flex-center-content" [ngStyle]="{ height: '100%' }">
    <div class="text-center">
      <img
        *ngIf="!loaderOverItem; else whiteImg"
        style="max-width: 160px; margin-bottom: 5px"
        [src]="logoBlack"
      />
      <ng-template #whiteImg>
        <img style="max-width: 160px; margin-bottom: 5px" [src]="logoWhite" />
      </ng-template>
      <br />
      <i
        class="fas fa-spin fa-circle-notch fa-2x"
        [ngClass]="{ 'text-white': loaderOverItem, 'text-body': !loaderOverItem }"
      ></i>
    </div>
  </div>
</div>
